<div class="container box-pie" [chart]="chart"></div>
<div class="back-text-chart">
    <div class="text-chart" [ngClass]="color">{{value}}</div>
</div>